import type { FC, ReactElement } from "react"
import { useEffect } from "react"

import { useSearchParams } from "react-router-dom"

import { ESpinnerSize, Loadable, Spinner } from "@/3514/components"
import { ECoachTab } from "@/3514/constants"

import Notifications from "./coach.dashboard.component.notifications"
import Title from "./coach.dashboard.component.title"
import {
    type TCoachDashboardDispatcher as TDispatcher,
    useCoachDashboardDispatcher as useDispatcher
} from "./coach.dashboard.store.dispatcher"
import classes from "./coach.dashboard.styles"
import { ECoachDashboardActiveTab } from "./coach.dashboard.ui.types"
import DataPanel from "./data-panel-entity"

const Page: FC = (): ReactElement => {
    const { changeTab }: TDispatcher = useDispatcher()

    const [searchParams]: ReturnType<typeof useSearchParams> = useSearchParams()

    const activeTab: ECoachDashboardActiveTab = ((): ECoachDashboardActiveTab => {
        const param: string = searchParams.get("tab")

        switch (param) {
            case ECoachTab.Dashboard.Participants:
                return ECoachDashboardActiveTab.Participants
            case ECoachTab.Dashboard.Sessions:
            default:
                return ECoachDashboardActiveTab.Sessions
        }
    })()

    useEffect((): void => {
        changeTab(activeTab)
    }, [activeTab, changeTab])

    return (
        <div className={classes.page.container()} key={`c-d-${activeTab}`}>
            <Title />

            <Notifications />

            <Loadable component={DataPanel} isReady loadingFallback={<Spinner size={ESpinnerSize.Large} />} />
        </div>
    )
}

Page.displayName = "CoachDashboardPage"

export { Page as CoachDashboardPage }
